/* ============================================================
   LOW KEY AUTOMOTIVE — THEME JS
   ============================================================ */

(function() {
  'use strict';

  // ── FIX NAV LINKS ──────────────────────────────────────────
  // Corrects any nav links pointing to missing pages/collections
  // Maps common link names to working filtered collection URLs
  var NAV_FIXES = {
    'shop by engine': { text: 'Shop',        href: '/collections/all' },
    'duramax':        { text: 'Duramax',      href: '/collections/duramax' },
    'powerstroke':    { text: 'Power Stroke', href: '/collections/powerstroke' },
    'power stroke':   { text: 'Power Stroke', href: '/collections/powerstroke' },
    'cummins':        { text: 'Cummins',      href: '/collections/cummins' },
  };

  function fixNavLabels() {
    document.querySelectorAll('.site-nav__link, .site-nav__dropdown a, .mobile-nav a').forEach(function(link) {
      var txt = link.textContent.trim().toLowerCase();
      if (NAV_FIXES[txt]) {
        link.textContent = NAV_FIXES[txt].text;
        // Only fix href if it points to a non-existent page (contains /pages/ or /collections/ with engine names)
        var h = link.getAttribute('href') || '';
        if (h.indexOf('/pages/') !== -1 || h === '#' || h === '' ||
            txt === 'shop by engine') {
          link.href = NAV_FIXES[txt].href;
        }
      }
    });
  }
  fixNavLabels();
  document.addEventListener('DOMContentLoaded', fixNavLabels);

  // ─── UTILITIES ────────────────────────────────────────────
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const off = (el, ev, fn) => el && el.removeEventListener(ev, fn);

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${parseFloat(dollars).toLocaleString('en-US', {minimumFractionDigits: 2})}`;
  }

  function showToast(msg, type = 'success') {
    let toast = $('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  }

  // ─── ANNOUNCEMENT BAR ─────────────────────────────────────
  const annClose = $('.announcement-bar__close');
  const annBar = $('.announcement-bar');
  if (annClose && annBar) {
    on(annClose, 'click', () => {
      annBar.style.display = 'none';
      sessionStorage.setItem('ann-closed', '1');
    });
    if (sessionStorage.getItem('ann-closed')) {
      annBar.style.display = 'none';
    }
  }

  // ─── SCROLL EFFECTS ───────────────────────────────────────
  const header = $('.site-header');
  const scrollTopBtn = $('#scrollTop');
  let lastScroll = 0;

  function handleScroll() {
    const scroll = window.scrollY;
    if (header) header.classList.toggle('scrolled', scroll > 20);
    if (scrollTopBtn) scrollTopBtn.classList.toggle('visible', scroll > 400);
    lastScroll = scroll;
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  if (scrollTopBtn) {
    on(scrollTopBtn, 'click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  // ─── MOBILE NAV ───────────────────────────────────────────
  const hamburger = $('.hamburger');
  const mobileNav = $('.mobile-nav');
  const overlay = $('#cart-overlay');

  function openMobileNav() {
    hamburger && hamburger.classList.add('open');
    mobileNav && mobileNav.classList.add('open');
    overlay && overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    hamburger && hamburger.classList.remove('open');
    mobileNav && mobileNav.classList.remove('open');
    if (!$('.cart-drawer.open')) {
      overlay && overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  on(hamburger, 'click', () => {
    mobileNav && mobileNav.classList.contains('open') ? closeMobileNav() : openMobileNav();
  });
  on($('.mobile-nav__close'), 'click', closeMobileNav);

  // ─── SEARCH MODAL ─────────────────────────────────────────
  const searchModal = $('#search-modal');
  const searchTriggers = $$('[data-search-open]');
  const searchClose = $('.search-modal__close');

  function openSearch() {
    searchModal && searchModal.classList.add('open');
    searchModal && searchModal.setAttribute('aria-hidden', 'false');
    setTimeout(() => $('.search-modal__input') && $('.search-modal__input').focus(), 100);
    document.body.style.overflow = 'hidden';
  }
  function closeSearch() {
    searchModal && searchModal.classList.remove('open');
    searchModal && searchModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  searchTriggers.forEach(t => on(t, 'click', openSearch));
  on(searchClose, 'click', closeSearch);
  on(searchModal, 'click', (e) => { if (e.target === searchModal) closeSearch(); });

  // ─── CART DRAWER ──────────────────────────────────────────
  const cartDrawer = $('#cart-drawer');
  const cartTriggers = $$('[data-cart-open]');
  const cartClose = $$('[data-cart-close]');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    overlay && overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    overlay && overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => on(t, 'click', openCart));
  cartClose.forEach(t => on(t, 'click', closeCart));
  on(overlay, 'click', () => { closeCart(); closeMobileNav(); });

  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeSearch(); closeMobileNav(); }
  });

  // ─── UPDATE CART COUNT ─────────────────────────────────────
  function updateCartCount(count) {
    $$('.cart-count').forEach(el => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }

  async function fetchCartCount() {
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      updateCartCount(cart.item_count);
    } catch(e) {}
  }
  fetchCartCount();

  // ─── ADD TO CART ──────────────────────────────────────────
  async function addToCart(variantId, quantity = 1, btn = null) {
    if (btn) {
      btn.disabled = true;
      const orig = btn.textContent;
      btn.textContent = 'Adding...';

      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        const item = await r.json();
        if (item.status) throw new Error(item.description || 'Error adding item');
        btn.textContent = '✓ Added!';
        btn.style.background = '#1a8a3a';
        setTimeout(() => {
          btn.textContent = orig;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
        fetchCartCount();
        fetchCartItems();
        openCart();
      } catch(err) {
        btn.textContent = 'Error — Try Again';
        btn.style.background = '#a32d2d';
        setTimeout(() => {
          btn.textContent = orig;
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
        showToast(err.message, 'error');
      }
    }
  }

  // ─── ADD TO CART FORMS (product page) ───────────────────
  $$('[data-add-to-cart]').forEach(function(form) {
    on(form, 'submit', async function(e) {
      e.preventDefault();
      var variantInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var btn = form.querySelector('[type="submit"]');
      if (!variantInput) return;
      await addToCart(variantInput.value, qtyInput ? parseInt(qtyInput.value) : 1, btn);
    });
  });

  // ─── QUICK ADD (event delegation — works on dynamically rendered cards) ──
  on(document, 'click', async function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    var variantId = btn.dataset.quickAdd;
    if (!variantId) return;

    // Visual feedback
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });
      var data = await r.json();
      if (data.status && data.status !== 200) throw new Error(data.description || 'Error');

      btn.textContent = '✓ Added!';
      btn.style.background = '#3db88c';
      btn.style.color = '#0a0a0a';

      // Update cart count + drawer immediately
      await fetchCartCount();
      await fetchCartItems();
      openCart();

      setTimeout(function() {
        btn.textContent = origText;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 2000);

    } catch(err) {
      btn.textContent = 'Try Again';
      btn.style.background = '#a32d2d';
      btn.style.color = '#fff';
      setTimeout(function() {
        btn.textContent = origText;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 2500);
    }
  });

  // ─── FETCH & RENDER CART ITEMS ────────────────────────────
  async function fetchCartItems() {
    const itemsContainer = $('#cart-drawer .cart-drawer__items');
    if (!itemsContainer) return;
    try {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      renderCartItems(cart, itemsContainer);
    } catch(e) {}
  }

  function renderCartItems(cart, container) {
    if (cart.item_count === 0) {
      container.innerHTML = `
        <div style="text-align:center;padding:48px 0;color:var(--color-gray);">
          <div style="font-size:3rem;margin-bottom:16px;opacity:0.3;">🛒</div>
          <p style="font-family:var(--font-condensed);font-weight:700;font-size:1rem;letter-spacing:0.08em;text-transform:uppercase;">Your cart is empty</p>
          <p style="font-size:0.85rem;margin-top:6px;">Add some parts to get started.</p>
        </div>`;
      const footer = $('.cart-drawer__footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    const footer = $('.cart-drawer__footer');
    if (footer) footer.style.display = '';

    container.innerHTML = cart.items.map(function(item) {
      var imgUrl = (item.featured_image && item.featured_image.url) ? item.featured_image.url : '';
      var variantHtml = item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
      return '<div class="cart-item" data-key="' + item.key + '">'
        + '<div class="cart-item__img"><img src="' + imgUrl + '" alt="" loading="lazy"></div>'
        + '<div>'
        + '<div class="cart-item__title">' + item.product_title + '</div>'
        + variantHtml
        + '<div class="qty-selector" style="margin-top:8px;">'
        + '<button type="button" data-qty-change="' + item.key + '" data-delta="-1" aria-label="Decrease">−</button>'
        + '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input="' + item.key + '" style="width:56px;height:42px;text-align:center;">'
        + '<button type="button" data-qty-change="' + item.key + '" data-delta="1" aria-label="Increase">+</button>'
        + '</div>'
        + '<div class="cart-item__remove" data-remove="' + item.key + '">Remove</div>'
        + '</div>'
        + '<div class="cart-item__price">' + formatMoney(item.line_price) + '</div>'
        + '</div>';
    }).join('');

    // Update subtotal
    const subtotalEl = $('.cart-drawer__subtotal-price');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Qty buttons
   $$('[data-qty-change]', container).forEach(btn => {
  on(btn, 'click', async function (e) {
    e.preventDefault();
    e.stopPropagation();

    const key = this.dataset.qtyChange;
    const delta = parseInt(this.dataset.delta, 10) || 0;
    const wrap = this.closest('.qty-selector');
    const input = wrap ? wrap.querySelector('[data-qty-input]') : null;
    const currentQty = parseInt(input && input.value, 10) || 0;
    const newQty = Math.max(0, currentQty + delta);

    await updateCartItem(key, newQty);
  });
});
    $$('[data-remove]', container).forEach(btn => {
      on(btn, 'click', () => updateCartItem(btn.dataset.remove, 0));
    });
  }

  async function updateCartItem(key, qty) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await r.json();
      updateCartCount(cart.item_count);
      const container = $('#cart-drawer .cart-drawer__items');
      if (container) renderCartItems(cart, container);
    } catch(e) {}
  }

  // ─── QUANTITY SELECTORS ────────────────────────────────────
 function initQtySelectors() {
  $$('.qty-selector').forEach(sel => {
    // Skip cart drawer
    if (sel.closest('#cart-drawer')) return;

    // Skip full cart page table
    if (sel.closest('table')) return;

    const input = sel.querySelector('input');
    if (!input) return;

    const btns = sel.querySelectorAll('button');
    btns.forEach(btn => {
      if (btn.dataset.qtyChange) return;

      on(btn, 'click', () => {
        const delta = btn.textContent.trim() === '+' ? 1 : -1;
        const min = parseInt(input.min) || 1;
        const newVal = Math.max(min, (parseInt(input.value) || 1) + delta);
        input.value = newVal;
      });
    });
  });
}
initQtySelectors();

  // ─── PRODUCT GALLERY ──────────────────────────────────────
  const thumbs = $$('.product-gallery__thumb');
  const mainImg = $('.product-gallery__main img');
  thumbs.forEach(thumb => {
    on(thumb, 'click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = thumb.dataset.fullSrc || thumb.querySelector('img')?.src;
          mainImg.style.opacity = '1';
        }, 150);
      }
    });
  });

  // ─── VARIANT SELECTOR ─────────────────────────────────────
  function updateProductUI(variant) {
    if (!variant) return;

    // 1. Update variant ID in form
    var idInput = document.querySelector('form[action="/cart/add"] [name="id"]');
    if (idInput) idInput.value = variant.id;

    // 2. Update price
    var priceMain    = document.querySelector('.price-main');
    var priceCompare = document.querySelector('.price-compare');
    var priceSave    = document.querySelector('.price-save');
    if (priceMain) priceMain.textContent = formatMoney(variant.price);
    if (priceCompare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatMoney(variant.compare_at_price);
        priceCompare.style.display = '';
        if (priceSave) {
          priceSave.textContent = 'Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
          priceSave.style.display = '';
        }
      } else {
        priceCompare.style.display = 'none';
        if (priceSave) priceSave.style.display = 'none';
      }
    }

    // 3. Update SKU
    var skuEl = document.querySelector('.product-info__sku');
    if (skuEl) skuEl.textContent = 'SKU: ' + (variant.sku || 'N/A');

    // 4. Update stock status
    var availEl = document.querySelector('.product-info__availability');
    if (availEl) {
      availEl.innerHTML = variant.available
        ? '<span style="color:var(--color-accent);">&#9679; IN STOCK</span>'
        : '<span style="color:var(--color-gray);">&#9679; OUT OF STOCK</span>';
    }

    // 5. Update Add to Cart button
    var addBtn = document.querySelector('form[action="/cart/add"] button[type="submit"]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.style.opacity = variant.available ? '' : '0.5';
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';
    }

    // 6. Swap image if variant has one
    if (variant.featured_image) {
      var mainImg = document.querySelector('.product-gallery__main img');
      if (mainImg) {
        mainImg.src = variant.featured_image.src;
        mainImg.alt = variant.featured_image.alt || '';
      }
    }
  }

  // Click handler — uses data-pos (option.position, 1-based) to find the right variant
  on(document, 'click', function(e) {
    var btn = e.target.closest('.variant-btn');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;

    // Mark only this button active within its group
    var group = btn.closest('[data-option-pos]');
    if (group) {
      group.querySelectorAll('.variant-btn').forEach(function(b) {
        b.classList.remove('active');
      });
    }
    btn.classList.add('active');

    // Build current selection: { 1: 'Black', 2: 'Large', ... }
    var sel = {};
    form.querySelectorAll('[data-option-pos]').forEach(function(g) {
      var pos    = parseInt(g.getAttribute('data-option-pos'));
      var active = g.querySelector('.variant-btn.active');
      if (active) sel[pos] = active.getAttribute('data-value');
    });

    // Find variant where option1/2/3 all match
    var variants = window.productVariants || [];
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var pos in sel) {
        if (v['option' + pos] !== sel[pos]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }

    if (match) updateProductUI(match);
  });

  function updateProductPrice(variant) { updateProductUI(variant); }

  // ─── TABS ─────────────────────────────────────────────────
  function openProductTab(target) {
    const tabsEl = $('[data-tabs]');
    if (!tabsEl || !target) return;
    const btn = $(`.tabs__nav button[data-tab="${target}"]`, tabsEl);
    $$('.tabs__nav button', tabsEl).forEach(b => b.classList.remove('active'));
    $$('.tabs__panel', tabsEl).forEach(p => p.classList.remove('active'));
    if (btn) btn.classList.add('active');
    const panel = $(`[data-tab-panel="${target}"]`, tabsEl);
    if (panel) {
      panel.classList.add('active');
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  $$('.tabs__nav button').forEach(btn => {
    on(btn, 'click', () => openProductTab(btn.dataset.tab));
  });

  $$('[data-tab-link]').forEach(link => {
    on(link, 'click', e => {
      e.preventDefault();
      openProductTab(link.getAttribute('data-tab-link'));
    });
  });

  // ─── FITMENT TABLE EXTRACTION ─────────────────────────────
  // Turn 14 embeds fitment tables inside product.description.
  // This moves any <table> or "This Part Fits" section out of the
  // Description tab and into the Vehicle Fitment tab automatically.
  (function extractFitmentTable() {
    var descEl = document.getElementById('product-description');
    var fitmentContainer = document.getElementById('fitment-table-container');
    if (!descEl || !fitmentContainer) return;

    // Find tables in description
    var tables = descEl.querySelectorAll('table');
    // Also look for "This Part Fits" heading
    var allEls = Array.from(descEl.children);
    var fitmentStart = -1;
    allEls.forEach(function(el, i) {
      if (el.textContent && el.textContent.match(/this part fits/i)) {
        fitmentStart = i;
      }
    });

    if (tables.length > 0 || fitmentStart !== -1) {
      var extracted = document.createElement('div');
      extracted.style.cssText = 'overflow-x:auto;';

      // Move "This Part Fits" header and everything after it
      if (fitmentStart !== -1) {
        for (var i = fitmentStart; i < allEls.length; i++) {
          extracted.appendChild(allEls[i].cloneNode(true));
        }
        // Remove from description
        for (var i = allEls.length - 1; i >= fitmentStart; i--) {
          if (allEls[i].parentNode === descEl) descEl.removeChild(allEls[i]);
        }
      } else {
        // Just move tables
        tables.forEach(function(table) {
          extracted.appendChild(table.cloneNode(true));
          table.parentNode.removeChild(table);
        });
      }

      // Style the extracted table
      extracted.querySelectorAll('table').forEach(function(t) {
        t.style.cssText = 'width:100%;border-collapse:collapse;font-size:0.88rem;';
        t.querySelectorAll('th').forEach(function(th) {
          th.style.cssText = 'background:var(--color-charcoal);color:var(--color-accent);font-family:var(--font-condensed);font-weight:700;letter-spacing:0.06em;text-transform:uppercase;padding:10px 14px;text-align:left;border-bottom:2px solid var(--color-accent);';
        });
        t.querySelectorAll('td').forEach(function(td) {
          td.style.cssText = 'padding:9px 14px;border-bottom:1px solid var(--color-border);color:var(--color-light-gray);';
        });
        t.querySelectorAll('tr:nth-child(even)').forEach(function(tr) {
          tr.style.background = 'rgba(255,255,255,0.02)';
        });
      });

      fitmentContainer.innerHTML = '';
      fitmentContainer.appendChild(extracted);
    } else {
      // No table found — show fallback message
      fitmentContainer.innerHTML = '<p style="color:var(--color-gray);">Fitment information not available for this product. <a href="/pages/contact" style="color:var(--color-accent);">Contact us</a> to confirm compatibility with your vehicle.</p>';
    }
  })();

  // ─── FILTER TOGGLES ───────────────────────────────────────
  $$('.filter-group__title').forEach(title => {
    on(title, 'click', () => {
      title.classList.toggle('open');
      const body = title.nextElementSibling;
      if (body) body.style.display = title.classList.contains('open') ? '' : 'none';
    });
  });

  // ─── VEHICLE SELECTOR ─────────────────────────────────────
  const yearSelect  = $('#vehicle-year');
  const makeSelect  = $('#vehicle-make');
  const modelSelect = $('#vehicle-model');

  if (yearSelect && makeSelect && modelSelect) {
    // Populate makes when year changes
    on(yearSelect, 'change', async () => {
      makeSelect.innerHTML = '<option value="">Select Make</option>';
      modelSelect.innerHTML = '<option value="">Select Model</option>';
      if (!yearSelect.value) return;
      // In production, this would hit a real endpoint
      // For demo, populate common diesel makes
      const makes = ['Chevrolet', 'Dodge', 'Ford', 'GMC', 'RAM'];
      makes.forEach(m => {
        const opt = document.createElement('option');
        opt.value = m.toLowerCase();
        opt.textContent = m;
        makeSelect.appendChild(opt);
      });
    });

    on(makeSelect, 'change', async () => {
      modelSelect.innerHTML = '<option value="">Select Model</option>';
      if (!makeSelect.value) return;
      const models = {
        chevrolet: ['Silverado 1500', 'Silverado 2500HD', 'Silverado 3500HD', 'Colorado'],
        dodge: ['Ram 1500', 'Ram 2500', 'Ram 3500'],
        ford: ['F-150', 'F-250', 'F-350', 'F-450', 'Ranger'],
        gmc: ['Sierra 1500', 'Sierra 2500HD', 'Sierra 3500HD', 'Canyon'],
        ram: ['1500', '2500', '3500', '4500', '5500']
      };
      (models[makeSelect.value] || []).forEach(m => {
        const opt = document.createElement('option');
        opt.value = m.toLowerCase().replace(/\s+/g, '-');
        opt.textContent = m;
        modelSelect.appendChild(opt);
      });
    });
  }

  // ─── LAZY IMAGES ──────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    const lazyImgs = $$('img[loading="lazy"]');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && e.target.dataset.src) {
          e.target.src = e.target.dataset.src;
          io.unobserve(e.target);
        }
      });
    });
    lazyImgs.forEach(img => io.observe(img));
  }

  // ─── ANIMATE ON SCROLL ────────────────────────────────────
  if ('IntersectionObserver' in window) {
    const aoEls = $$('[data-aos]');
    if (aoEls.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.style.opacity = '1';
            e.target.style.transform = 'none';
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
      aoEls.forEach(el => {
        el.style.transition = `opacity 0.6s ease ${el.dataset.delay || '0'}ms, transform 0.6s ease ${el.dataset.delay || '0'}ms`;
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        observer.observe(el);
      });
    }
  }

  // ─── NEWSLETTER ───────────────────────────────────────────
  $$('[data-newsletter-form]').forEach(form => {
    on(form, 'submit', async (e) => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]');
      if (!email || !email.value) return;
      showToast('Thanks! You\'re now subscribed to Low Key Automotive.');
      email.value = '';
    });
  });

  // ─── SWATCHES (colour variant) ────────────────────────────
  $$('[data-swatch]').forEach(swatch => {
    on(swatch, 'click', () => {
      const group = swatch.closest('[data-swatch-group]');
      if (group) $$('[data-swatch]', group).forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
    });
  });

  // ─── FILTER SIDEBAR MOBILE TOGGLE ─────────────────────────
  // Filter mobile toggle — use event delegation so innerHTML swap doesn't break it
  on(document, 'click', (e) => {
    const btn = e.target.closest('.filter-mobile-toggle');
    if (!btn) return;
    const sidebar = $('.sidebar');
    if (!sidebar) return;
    const isOpen = sidebar.classList.toggle('mobile-open');
    // Update text node only, not whole innerHTML (keeps listener intact)
    const textNode = [...btn.childNodes].find(n => n.nodeType === 3);
    if (textNode) textNode.textContent = isOpen ? ' Close Filters' : ' Filter';
    // Toggle icon
    const icon = btn.querySelector('svg path');
    if (icon) icon.setAttribute('d', isOpen
      ? 'M2 2L12 12M12 2L2 12'
      : 'M1 3H13M3 7H11M5 11H9');
    // Overlay
    const overlay = $('#sidebar-overlay');
    if (overlay) overlay.style.display = isOpen ? 'block' : 'none';
  });
  // Close sidebar when overlay is clicked
  on(document, 'click', (e) => {
    if (!e.target.closest('#sidebar-overlay')) return;
    const sidebar = $('.sidebar');
    if (sidebar) sidebar.classList.remove('mobile-open');
    const overlay = $('#sidebar-overlay');
    if (overlay) overlay.style.display = 'none';
    const btn = $('.filter-mobile-toggle');
    if (btn) {
      const textNode = [...btn.childNodes].find(n => n.nodeType === 3);
      if (textNode) textNode.textContent = ' Filter';
      const icon = btn.querySelector('svg path');
      if (icon) icon.setAttribute('d', 'M1 3H13M3 7H11M5 11H9');
    }
  });

  // ─── INIT ─────────────────────────────────────────────────
    var NAV_MAP = {'shop by engine':['/collections/all','Shop'],'duramax':['/collections/duramax','Duramax'],'powerstroke':['/collections/powerstroke','Power Stroke'],'cummins':['/collections/cummins','Cummins']};
  document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.site-nav__link,.mobile-nav a').forEach(function(l){var k=l.textContent.trim().toLowerCase();if(NAV_MAP[k]){var h=l.getAttribute('href')||'';if(h.indexOf('/pages/')!==-1||h===''||h==='#')l.href=NAV_MAP[k][0];}});});

  console.log('Low Key Automotive theme loaded ✓');

})();
